import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import EvaluationCriteriaForm from './Form';
import GraphQL from '../../../GraphQL';
import {
  evaluationCriteriaSave,
  evaluationCriteriaListByFilter,
} from '../../../shared/queries/EvaluationCriteria';
import SmartCard from '../../../shared/components/SmartCard';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';

const EvaluationCriteriaFormHandler = (props) => {
  const { match, t, history, dispatch } = props;

  const [dto, setDto] = useState({ id: 0, active: true });
  const [formOn, setFormOn] = useState(false);

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  function backClickHandler() {
    history.push('/minime/criterio-avaliacao');
  }

  const handleSubmit = (values) => {
    showLoading();
    const mutationQuery = evaluationCriteriaSave(values);
    GraphQL(mutationQuery, {})
      .then(() => {
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  function findById(id) {
    showLoading();
    const filter = {
      filterByStatus: false,
      updaterId: 0,
      active: true,
      id,
    };
    const query = evaluationCriteriaListByFilter(filter);
    GraphQL(query, {})
      .then((res) => {
        if (res.evaluationCriteriaListByFilter) {
          setDto({
            ...res.evaluationCriteriaListByFilter[0],
          });
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch((error) => {
        if (error.response) {
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        }
      })
      .finally(() => {
        hideLoading();
      });
  }

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  return (
    <SmartCard title={t('panels.criterio-avaliacao')}>
      {formOn ? (
        <EvaluationCriteriaForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          dto={dto}
        />
      ) : null}
    </SmartCard>
  );
};

EvaluationCriteriaFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(EvaluationCriteriaFormHandler)
);
